import { gql } from '@apollo/client';

export const BridgeQuery = gql`
  query BridgeInfo {
  res: bridgeInfo {
    opSystem
    system
    version
    downloadUrl
    updateUrl
    changelog
  }
}`;

export const SMARTCASES = gql`
  query SmartCases($teamId: ID!, $userId: ID!) {
    res: discoverSmartcases(teamId: $teamId, userId: $userId) {
      serial
    }
  }
`;

export const SMARTCASES_DETAILS = gql`
  query SmartCasesDetails($teamId: ID!, $userId: ID!) {
    res: discoverSmartcases(teamId: $teamId, userId: $userId) {
      serial
      newDeviceVersion
      settings
      systemVersion
      systemUpdateVersion
      updateDevices
      devices {
        uuid
        transferProgress
        soc
        serialId
        memory
        fwVersion
        athlete
        active
        sync

        configuration {
          accelerometer {
            enable
            stored
            frequency
          }
          gyroscope {
            enable
            stored
            frequency
          }
          magnetometer {
            enable
            stored
            frequency
          }

          constellation
          elevation

          eventsSetValue
          jumpThreshold
          impactMinAccThreshold
          impactMinAvgAccThreshold
          impactMaxAvgSpeedThreshold
          impactMaxDtFromLastImpactThreshold
          impactMaxDurationThreshold

          flags {
            satsInView
            continuousMagCalibration
            enableMagnCalibration
            buzzOnCardio
            buzzOnJump
            buzzOnImpact
            enableAhrs
            longTurnoffPress
            useMagnCalibrationFlags
            forceBatteryEstimate
          }

          telemetryRadioSetup {
            channel0
            channel1
            togglingTime
            timeout
          }
        }
      }
    }
  }
`;
